import { useContext } from 'react';
import { NotificationContext } from './context/NotificationContext';

export { NotificationManager } from './components/NotificationManager/NotificationManager';
export { NotificationList } from './components/NotificationList/NotificationList';

export { Level } from './constants/Level';
export { Duration } from './constants/Duration';

export { withNotify } from './hoc/withNotify';
export { WithNotifyFunctionProps } from './types/WithNotifyFunctionProps';

export const useNotify = () => useContext(NotificationContext).notify;
export const useNotifications = () => useContext(NotificationContext).notifications;
